"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storage = void 0;
/* eslint-disable no-underscore-dangle */
var myMap = new Map();
var storage = function () { return ({
    getItem: function (key) { return myMap.get(key); },
    setItem: function (key, value) {
        myMap.set(key, value);
        // this is so we can see anything in the cache in the Context dev-tool that we already use for the app.
        // this is not a Context but it is handy having a way of previewing what is in the cache.
        if (window._REACT_CONTEXT_DEVTOOL) {
            window._REACT_CONTEXT_DEVTOOL({ id: 'CACHE', displayName: 'APP CACHE Storage', values: Object.fromEntries(myMap) });
        }
    },
}); };
exports.storage = storage;
//# sourceMappingURL=app.js.map